import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxRebates from "./_components/BoxRebates";

const Rebates = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxRebates />
    </ContentWrapper>
  </>
);

export default Rebates;
